module.exports = __webpack_public_path__ + "img/c02_unitstartechchariotarcherchampion_Normal_ua.55a6d354.webp";